import { render, staticRenderFns } from "./benefitsHome.vue?vue&type=template&id=68821694&"
import script from "./benefitsHome.vue?vue&type=script&lang=js&"
export * from "./benefitsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports